import { DateTime } from 'luxon';
import { logger } from '@amzn/atoz-shiftapp-metrics';
export var isStarted = function (startTimeIso) {
    var startTime = DateTime.fromISO(startTimeIso);
    if (!startTime.isValid) {
        logger.emitError('ShiftUtils.isStarted did not receive the necessary data');
        return false;
    }
    return DateTime.local() >= startTime;
};
